window.addEventListener('DOMContentLoaded', () => {

  let afterpayCounter = 0;

  const afterpayInterval = setInterval(() => {

    const afterpay = document.querySelector('square-placement');

    if (!!afterpay) {

      const previousElement = document.querySelector('.pay-later__container');

      previousElement?.insertAdjacentElement('afterend', afterpay.parentElement);
      clearInterval(afterpayInterval)

    }
    else if (afterpayCounter < 150) afterpayCounter += 1
    else clearInterval(afterpayInterval)

  }, 50);

})